import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StepperComponent } from '@shared/components/stepper/stepper.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { interval, Subject, timer } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ChangeTagsService } from '../change-tags.service';
import { Steps, TagStep } from './tag-change-stepper.model';

@UntilDestroy()
@Component({
  selector: 'miq-tag-change-stepper',
  templateUrl: 'tag-change-stepper.component.html',
  styleUrls: ['tag-change-stepper.component.scss'],
  providers: [ChangeTagsService],
  standalone: false,
})
export class TagChangeStepperComponent implements OnInit, OnDestroy {
  private currentStep = TagStep.TagSelection;
  private stopLoadingNotification: Subject<void> = new Subject();

  public catastrophicFailure = false;
  public thereAreErrors = false;
  public loaderValue = 5;
  @ViewChild('stepper', { static: true }) stepper: StepperComponent;

  constructor(
    public dialogRef: MatDialogRef<TagChangeStepperComponent>,
    public changeTagService: ChangeTagsService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.changeTagService.setParams(data.entity, data.entitiesIds);
  }

  ngOnInit() {
    this.changeTagService.notificationToNext.pipe(untilDestroyed(this)).subscribe(isOk => {
      this.catastrophicFailure = !isOk;
      this.currentStep = Steps.get(this.currentStep);
      this.checkNextStepState();
    });
  }

  ngOnDestroy() {
    // Needed for until destroyed operator
  }

  private checkNextStepState() {
    switch (this.currentStep) {
      case TagStep.Processing:
        this.startLoadingAnimation();
        this.stepper.next();
        break;
      case TagStep.FinalNotification:
        this.finishLoading();
        break;
    }
  }

  private finishLoading() {
    this.stopLoadingNotification.next();
    this.stopLoadingNotification.complete();
    this.loaderValue = 100;
    setInterval(() => {
      this.stepper.next();
      this.checkFinalState();
    }, 500);
  }

  private checkFinalState() {
    if (!this.catastrophicFailure) {
      this.thereAreErrors = this.changeTagService.recordsWithErrors.length > 0 || this.catastrophicFailure;
      if (!this.thereAreErrors) {
        timer(3000)
          .pipe(untilDestroyed(this))
          .subscribe(_ => {
            if (this.dialogRef != null) {
              this.dialogRef.close();
            }
          });
      }
    } else {
      this.thereAreErrors = true;
    }
  }

  private startLoadingAnimation() {
    const numberOfRecords = this.changeTagService.entityIds.length;
    const loadStepSize = 95 / numberOfRecords;
    interval(842)
      .pipe(takeUntil(this.stopLoadingNotification), take(numberOfRecords))
      .subscribe(_ => {
        let newValue = this.loaderValue + loadStepSize;
        if (newValue > 95) {
          newValue = 95;
        }
        this.loaderValue = newValue;
      });
  }
}
